import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    padding: 0;
  }

  .category{
    @media (max-width: 767px) {
     display: none;
    }
  }
`;
